import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d37a722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Performances (off-chain)", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  width: "100%",
  height: "450",
  scrolling: "no",
  frameborder: "no",
  allow: "autoplay",
  src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1322369266&color=%23ff5500&auto_play=true&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"10px","color":"#cccccc","line-break":"anywhere","word-break":"normal","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis","font-family":"Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif","font-weight":"100"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://soundcloud.com/jqrgen",
    title: "jQrgen",
    target: "_blank",
    style: {"color":"#cccccc","text-decoration":"none"}
  }, "jQrgen"),
  /*#__PURE__*/_createTextVNode(" · "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://soundcloud.com/jqrgen/sets/doener-tallrik-dj-bord",
    title: "Döner Tallrik & Dj Bord",
    target: "_blank",
    style: {"color":"#cccccc","text-decoration":"none"}
  }, "Döner Tallrik & Dj Bord")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Døner NFT 4 sale (Til salgs)", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createTextVNode("See "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/82846146539956530579045854039281485655757396760242173571066962143559188217857" }, "OpenSea")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nft_card = _resolveComponent("nft-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.msg), 1)
    ]),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _createVNode(_component_nft_card, {
      contractAddress: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      tokenId: "82846146539956530579045854039281485655757396760242173571066962143559188217857"
    })
  ], 64))
}